export default function ({ language }) {
  var config = {
    label: language['organization-identity-label'],
    placeholder: language['organization-identity-placeholder'],
    maxLength: 11,
    validators: ['mandatory', 'minChars:9;Må bestå av --x-- siffer'],
  };

  return {
    config,
    extendsType: 'text-field',
    validators: [
      function organizationNumber(state, config) {
        if (validateOrganizationNumber(state.value)) return false;
        else return language['organization-identity-invalid'];
      },
    ],
  };
}

function validateOrganizationNumber(number) {
  var trimmed = Array.prototype.filter.call(number, (char) => char.match(/[0-9]/)).join('');
  var digit = controlDigits(trimmed);
  return trimmed.length === 9 && trimmed[8] == digit;
}

function controlDigits(identificationNumber) {
  return [[3, 2, 7, 6, 5, 4, 3, 2]].map(controlDigit).join('');

  function controlDigit(products) {
    var sum = products
      .map((product, index) => {
        return product * String(identificationNumber)[index];
      })
      .reduce((a, b) => a + b);
    var digit = 11 - (sum % 11);
    return digit === 11 ? 0 : digit;
  }
}
